/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/web-app-bff-api-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/web-app-bff-api-client";
import type { CloneProjectVideoEditorProjectsMutationRequest, CloneProjectVideoEditorProjectsMutationResponse, CloneProjectVideoEditorProjectsPathParams } from "../models/CloneProjectVideoEditorProjects";

export function getCloneProjectVideoEditorProjectsUrl(id: CloneProjectVideoEditorProjectsPathParams["id"]) {
  const res = { method: 'POST', url: `/video-editor/projects/${id}/clone` as const }
  return res
}

/**
 * @summary Clone a project (requires new name); response includes creator and published platforms
 * {@link /video-editor/projects/:id/clone}
 */
export async function cloneProjectVideoEditorProjects(id: CloneProjectVideoEditorProjectsPathParams["id"], data: CloneProjectVideoEditorProjectsMutationRequest, config: Partial<RequestConfig<CloneProjectVideoEditorProjectsMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<CloneProjectVideoEditorProjectsMutationResponse, ResponseErrorConfig<Error>, CloneProjectVideoEditorProjectsMutationRequest>({ method : "POST", url : getCloneProjectVideoEditorProjectsUrl(id).url.toString(), data : requestData, ... requestConfig })
  return res.data
}